import { Link } from 'react-router-dom'

interface Idea {
  id: string
  name: string
  canon_files: string[]
  phase: string
}

interface CanonSidebarProps {
  ideas: Idea[]
  selectedIdea: string | null
  selectedDoc: string | null
  tableOfContents: Array<{ id: string; level: number; text: string }>
  onTocClick: (id: string) => void
}

export default function CanonSidebar({
  ideas,
  selectedIdea,
  selectedDoc,
  tableOfContents,
  onTocClick,
}: CanonSidebarProps) {
  const currentIdea = ideas.find((i) => i.id === selectedIdea)

  return (
    <div className="w-80 flex-shrink-0 border-r border-gray-800 bg-gray-950 overflow-y-auto">
      {/* Ideas Section */}
      <div className="p-4 border-b border-gray-800">
        <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3">
          Ideas
        </h2>
        <div className="space-y-1">
          {ideas.map((idea) => (
            <Link
              key={idea.id}
              to={`/canon/${idea.id}`}
              className={`block px-3 py-2 rounded-md text-sm transition-colors ${
                selectedIdea === idea.id
                  ? 'bg-brand-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800'
              }`}
            >
              <div className="font-medium">{idea.name}</div>
              <div className="text-xs opacity-75">Phase {idea.phase}</div>
            </Link>
          ))}
        </div>
      </div>

      {/* Canon Documents Section */}
      {currentIdea && (
        <div className="p-4 border-b border-gray-800">
          <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3">
            Canon Documents
          </h2>
          <div className="space-y-1">
            {currentIdea.canon_files.map((doc) => (
              <Link
                key={doc}
                to={`/canon/${currentIdea.id}/${doc}`}
                className={`block px-3 py-2 rounded-md text-sm transition-colors ${
                  selectedDoc === doc
                    ? 'bg-brand-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800'
                }`}
              >
                {doc}
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Table of Contents Section */}
      {tableOfContents.length > 0 && (
        <div className="p-4">
          <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3">
            Table of Contents
          </h2>
          <nav className="space-y-1">
            {tableOfContents.map((heading) => (
              <button
                key={heading.id}
                onClick={() => onTocClick(heading.id)}
                className="block w-full text-left px-3 py-1.5 rounded-md text-sm text-gray-300 hover:bg-gray-800 transition-colors"
                style={{ paddingLeft: `${(heading.level - 1) * 0.75 + 0.75}rem` }}
              >
                {heading.text}
              </button>
            ))}
          </nav>
        </div>
      )}
    </div>
  )
}
